import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@src/lib/ui/AlertDialog";
import { Button } from "@src/lib/ui/Button";
import { FC } from "react";

type Props = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  employeeName: string;
  onDelete: () => Promise<void>;
};

export const DeleteHrisEmployeeDialog: FC<Props> = ({
  open,
  onOpenChange,
  employeeName,
  onDelete,
}) => {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Delete HRIS employee?</AlertDialogTitle>
          <AlertDialogDescription asChild>
            <div>
              <div className="mb-3">
                Are you sure you want to delete the HRIS employee &quot;
                {employeeName}
                &quot;? This action cannot be undone.
              </div>
              <div>
                If the HRIS employee being deleted still exists in your HRIS,
                they will get recreated in Opus during the next sync.
              </div>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button variant="destructive" onClick={onDelete}>
            Delete
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
